import { render, staticRenderFns } from "./DetailsDomainDepositsByOffers.vue?vue&type=template&id=42bdc4f7"
import script from "./DetailsDomainDepositsByOffers.vue?vue&type=script&lang=js"
export * from "./DetailsDomainDepositsByOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports